import { createContext } from 'react'
import { InitialStateContext, initialStateContext } from './initial_states'

const AppContext = createContext<InitialStateContext>(initialStateContext)

export const ContextProvider = AppContext.Provider

export default AppContext
